<div class="page-skeleton">
  <div class="skeleton-container">
    <!-- Search bar skeleton -->
    <div class="skeleton-search">
      <div class="skeleton-input"></div>
      <div class="skeleton-button"></div>
    </div>

    <!-- Filters skeleton -->
    <div class="skeleton-filters">
      <div class="skeleton-filter-item"></div>
      <div class="skeleton-filter-item"></div>
      <div class="skeleton-filter-item"></div>
      <div class="skeleton-filter-item"></div>
    </div>

    <!-- Cards skeleton -->
    <div class="skeleton-cards">
      <div class="skeleton-card" *ngFor="let item of [1,2,3,4,5,6]">
        <div class="skeleton-card-image"></div>
        <div class="skeleton-card-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-subtitle"></div>
          <div class="skeleton-line skeleton-line-text"></div>
          <div class="skeleton-card-footer">
            <div class="skeleton-line skeleton-line-small"></div>
            <div class="skeleton-line skeleton-line-small"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
